import React, { useEffect } from "react";
import Routes from "./Routes";
import { createRoot } from "react-dom/client";
import { Toaster } from "react-hot-toast";

const App = () => {
  return (
    <div className="app-shell">
      {/* <ErrorBoundary> */}
      <Routes />
      <Toaster
        position="bottom-center"
        toastOptions={{
          duration: 2000,
        }}
      />
      {/* </ErrorBoundary> */}
    </div>
  );
};

createRoot(document.querySelector("#root")).render(<App />);
